
import { mapActions } from "vuex";
import { ORDER_CANCELLED } from "@/constants/MixpanelEvents.js";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  props: {
    dialog: false,
    orderDetailObj: {}
  },
  components: { ResponsiveDialog },

  data() {
    return {
      loading: false,
      rejectReasons: [
        { value: "item_out_of_stock", title: "item out of stock" },
        { value: "store_closed", title: "store closed" },
        { value: "store_busy", title: "store busy" },
        { value: "rider_not_available", title: "rider not available" },
        { value: "out_of_delivery_radius", title: "out of delivery radius" },
        { value: "connectivity_issue", title: "connectivity issue" },
        { value: "total_missmatch", title: "total missmatch" },
        { value: "invalid_item", title: "invalid item" },
        { value: "option_out_of_stock", title: "option out of stock" },
        { value: "invalid_option", title: "invalid option" },
        { value: "unspecified", title: "unspecified" }
      ],
      selectedReason: ""
    };
  },
  methods: {
    ...mapActions("reciever", ["patchOrderStatus"]),
    handleCancelOrder() {
      this.loading = true;
      this.patchOrderStatus({
        orderId: this.orderDetailObj.id,
        payload: {
          new_status: "Cancelled",
          message: this.selectedReason
        }
      })
        .then((response) => {
          if (response.status === 200) {
            this.mixPanelTrackEvent(ORDER_CANCELLED);
            this.$nuxt.$emit("show-info-dialog", {
              content: "The order is cancelled from your end"
            });
            this.$emit("close-dialog");
          } else {
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
